// extracted by mini-css-extract-plugin
export var bodySections = "_91-8";
export var gray = "_91-7";
export var green = "_91-4";
export var iconContainer = "_91-9";
export var iconWidgetContainer = "_91-1";
export var phoneIcon = "_91-2";
export var red = "_91-5";
export var statusDot = "_91-3";
export var widgetContainer = "_91-0";
export var yellow = "_91-6";